import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { Menu, MenuItems, Title } from './styles';
import { MenuItem } from '../menuItem';
import { ReportMenuSectionProps } from '../../../interfaces/navbarInterface';
import { useLocation } from 'react-router-dom';
import { Line } from '../settingNavbar/styles';
import { ROUTES } from '../../../routes/urls';

interface MenuItemInterface {
  path?: string;
  iconName?: string;
  label?: string;
}
const MenuSection: React.FC<ReportMenuSectionProps> = observer(({ title, items, showDivider }) => {
  const location = useLocation();

  const getIsActive = useCallback((item: MenuItemInterface, pathname: string) => {
    if (!item?.path) return false;
    // Special case for Integrations
    if (item.label === 'Integrations') {
      return pathname.startsWith(ROUTES.INTEGRATIONS_DETAILS) || (item.path && pathname.startsWith(item.path));
    }
    // Default case
    return item.path && pathname.startsWith(item.path);
  }, []);

  return (
    <>
      <Menu>
        {title && (
          <Title>
            <p>{title}</p>
          </Title>
        )}
        <MenuItems>
          {items.map((item, idx) => {
            if (item.customComponent) {
              return <React.Fragment key={item.label || `custom-${idx}`}>{item.customComponent}</React.Fragment>;
            }
            const isActive = getIsActive(item, location.pathname) || false;
            return (
              <MenuItem
                key={item.label}
                iconName={item.iconName}
                isActive={isActive}
                label={item.label}
                path={item.path}
                count={item.count}
              />
            );
          })}
        </MenuItems>
      </Menu>
      {showDivider && <Line />}
    </>
  );
});

export default MenuSection;
